import * as XLSX from "xlsx";
import moment from "moment";
import notifier from "utils/notifier";
import { getDisplayCompanyId } from "utils/helpers";
import {
  HmoAwvMetricsModel,
  HmoMemberAwvDetailsModel,
  MemberBatchUpdateModel,
  MemberExcelStatusModel,
  MemberPafModel,
  RefreshMemberAwvStatusModel,
  MemberMpiSearchModel,
} from "store/app/hmo/actions";

export const createExcelFile = (data: any[]) => {
  const downloadData = data.map((row) => ({
    Name: row.RmiMemberName,
    Gender: row.RmiGender,
    MedicareId: row.RmiMedicareId,
    "Date of Birth": row.RmiBirth,
    "Last Visit": row.RmiLastVisit,
    Status: row.RmiCompleted ? "Completed" : "Incomplete",
  }));

  const currTime = moment().format("MMMM Do YYYY");
  const worksheet = XLSX.utils.json_to_sheet(downloadData);
  const workbook = XLSX.utils.book_new();
  worksheet["!cols"] = [
    { wch: 15 },
    { wch: 10 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
  ];
  XLSX.utils.book_append_sheet(workbook, worksheet, "Members AWV");

  XLSX.writeFile(workbook, `AcoAwvMembers-${currTime}.xlsx`)
    .then(notifier.success("Successfully Exported"))
    .catch((error: any) => notifier.error("Export Unsuccessful."));
};

export const formatName = (providers: any) => {
  providers.forEach((data: any) => {
    if (data.rmiRevFullName !== null) {
      const splitData = data.rmiRevFullName.split(",");
      data.rmiRevFullName = splitData.join(", ");
    }
    data.Provider =
      getDisplayCompanyId(data.rmiCompanyId) +
      " - (" +
      data.RmiClass +
      ") " +
      data.rmiRevFullName;
  });

  return providers;
};

export type SummaryBoxProps = {
  title: string;
  value: any;
  percentage: any;
  isStarRating: boolean;
  isFetchingHmoMetrics: boolean;
  starScore: number;
};

export interface HmoTableProps {
  isFetchingAwv: boolean;
  selectedProviderKeyId: string;
  isFetchingDistinct: boolean;
  isFetchingHmoMetrics: boolean;
  isUpdatingHmoMetrics: boolean;
  isRefreshingMemberAwvStatus: boolean;
  isDownloadingMemberPafs: boolean;
  isDownloadingMemberStatusExcel: boolean;
  getDistinct(userId: string): any;
  getMemberAwvDetails(payload: HmoMemberAwvDetailsModel): any;
  getHmoAwvMetrics(payload: HmoAwvMetricsModel): any;
  updateMemberAwvStatus(payload: MemberBatchUpdateModel): any;
  refreshMemberAwvStatus(payload: RefreshMemberAwvStatusModel): any;
  downloadMemberPafs(payload: MemberPafModel): any;
  downloadAwvStatusExcel(payload: MemberExcelStatusModel): any;
  downloadAwvStatusPdf(payload: MemberExcelStatusModel): any;
  getMemberMpi(payload: MemberMpiSearchModel): any;
  uploadFilestoAuth(options: Object): any;
}

export interface PatientRecord {
  MemberId: string;
  MemberKeyId: string;
  MemberMbi: string;
  MemberName: string;
  MemberGender: string;
  MemberBirth: string;
  MemberPhone: string;
  MemberType: string;
  MemberHccCount: number;
  HedisGaps: number;
  LastAwvDate: string;
  AwvDueDate: string;
  PreviousAwvRecords: string;
  CurrentRafScore: string;
  CurrentRafScoreDate: string;
  CountOpenCareGaps: number;
  PreviousRafScore: string;
  PreviousRafScoreDate: string;
  AwvStatus: string;
  MeasureYear: number;
  ProviderId: string;
  ProviderNpi: string;
}

export const summaryBoxDataInit = [
  {
    id: 1,
    title: "AWVs Complete",
    value: "",
    percentage: "",
    isStarRating: false,
  },
  {
    id: 2,
    title: "AWVs Performed, Claim Pending",
    value: "",
    percentage: "",
    isStarRating: false,
  },
  {
    id: 3,
    title: "AWV STAR Score",
    value: "",
    isStarRating: true,
  },
  {
    id: 4,
    title: `${moment().year()} Estimated RAF YTD`,
    value: "",
    isStarRating: false,
  },
];

export enum AWVMemberType {
  HMO = "HMO",
  ACO = "ACO",
}

export enum AWVStatusFilter {
  VisitNeeded = "Visit Needed",
  Scheduled = "Scheduled",
  PerformedClaimPending = "Performed Claim Pending",
  NotYetEligible = "Not Yet Eligible",
  Completed = "Completed",
}

export enum AWVMemberTypeFilter {
  ACOOnly = "ACO Only",
  HMOOnly = "HMO Only"
}

export enum AWVStatus {
  Needed = "Needed",
  Pending = "Pending",
  Completed = "Completed",
  Scheduled = "Scheduled",
}